module.exports = __webpack_public_path__ + "img/lefttop.906cda07.png";